import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

const defaultStyles = {
    color: 'inherit',
    fontSize: 24,
    fontWeight: 100,
    lineHeight: '1.3em',
    textMargin: 8,
};

const styles = (theme) => ({

});

class Banner extends Component {
  constructor(props) {
    super(props);
    this.backgroundPath = props.appTheme.backgroundPath;
    this.heroStyle = {
      color: props.appTheme.banner.color,
      backgroundColor: props.appTheme.banner.backgroundColor,
      custom: props.appTheme.banner.custom,
    };
  }
  createCustomMarkup() {
    return {__html: this.heroStyle.custom};
  }
  render() {
      const { appTheme: { banner: { line1, line2, color, fontSize, fontWeight, textMargin, position = 'top right', text = '' } }} = this.props;
      const textStyles = Object.assign({}, {
          color: color || defaultStyles.color,
          fontSize: `${fontSize || defaultStyles.fontSize}px`,
          fontWeight: fontWeight || defaultStyles.fontWeight,
          margin: `${textMargin || defaultStyles.textMargin}px 0`,
      });

      const bannerInTheMiddle = position === 'center';

      const BannerCenter = (
          <div
            className="Banner Banner-Center">
            <div
              style={this.heroStyle}
              className="HeroBox">
              {line1 && <p
                  style={textStyles}
                  className="text line-1">{line1}</p>}
              <img
                src={this.backgroundPath}
                className="Banner-Image"
                alt="" />
              {line2 && <p
                  style={textStyles}
                  className="text line-2">{line2}</p>}
            </div>
          </div>
      );

      const BannerCorner = (
          <div
            className={`Banner ${position.split(' ').map((pos) => `Banner-${pos.toLowerCase()}`).join(' ')}`}>
            <img
              src={this.backgroundPath}
              className="Banner-Image"
              alt="" />
            <div
              style={this.heroStyle}
              className="HeroBox">
              {line1 && <p
                  style={textStyles}
                  className="text line-1">{line1}</p>}
              {line2 && <p
                  style={textStyles}
                  className="text line-2">{line2}</p>}
              {!line1 && <p
                className="text">{text.split('\n').map((item, key) => <span key={key}>{item}<br/></span>)}</p>}
            </div>
          </div>
      );

    return (
        bannerInTheMiddle ? BannerCenter : BannerCorner
    );
  }
}

export default withStyles(styles)(Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js